import { useQueryState } from "nuqs";
import { Img } from "@/components/image";
import { Button } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import type { DietHubDietCategoryType } from "@/features/hubs/types/diet-hub.type";
import { strapiUrl } from "@/lib/strapi";
import { cn } from "@/lib/utils";

export const DietHubHeroCategoriesCarousel = ({
  categories,
  activeCategoryId,
}: {
  categories: DietHubDietCategoryType[] | undefined;
  activeCategoryId: number | undefined;
}) => {
  const [, setSelectedCategoryId] = useQueryState("category", {
    shallow: true,
    parse: (value) => Number.parseInt(value as string, 10),
    serialize: (value) => value?.toString(),
  });

  if (!categories) {
    return null;
  }

  return (
    <Carousel opts={{ align: "start" }}>
      <CarouselContent className="w-full lg:ml-0">
        {categories.map((category) => (
          <CarouselItem
            key={category.id}
            className="ml-0 basis-auto pl-0"
            onClick={() => setSelectedCategoryId(category.id)}
          >
            <Button
              variant="ghost"
              onClick={() => setSelectedCategoryId(category.id)}
              className={cn(
                "h-auto gap-2 rounded-none border-b-2 px-4 py-2.5 font-medium text-brand-grey5 text-lg leading-6 hover:bg-transparent hover:text-brand-green2-300",
                activeCategoryId === category.id
                  ? "border-brand-green2-300 text-brand-green2-300"
                  : "border-brand-grey2",
              )}
            >
              {/* icon */}
              {category.icon?.url ? (
                <Img
                  src={strapiUrl(category.icon.url)}
                  alt={category.icon.alternativeText ?? ""}
                  width={category.icon.width}
                  height={category.icon.height}
                  className="size-4 object-cover"
                />
              ) : null}
              <span>{category.title}</span>
            </Button>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
